class MFRProductStickyBar {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
          firstSection: "main .shopify-section:first-child",
          excludedSections: "[data-hide-product-sticky-bar]",
        }; 

        this.init();
    }

    init() {
        if( !gsap || !ScrollTrigger || !ScrollTrigger.create ) return;

        this.$firstSection = $( this.selectors.firstSection );
        this.$excludedSections = $(this.selectors.excludedSections);

        this.initScrollTrigger();
    }

    initScrollTrigger() {
        ScrollTrigger.create({
          trigger: this.$firstSection,
          start: "30% top",
          endTrigger: "html",
          end: "bottom top",
          onToggle: self => {
            this.$element.toggleClass( "is-active", self.isActive );
          }
        });

        this.initAvoidProductStickyBarSections();;
    }

    initAvoidProductStickyBarSections() {
        if(!this.$excludedSections.length) return;

        ScrollTrigger.create({
          trigger: this.$excludedSections,
          start: "top 30%",
          end: "bottom 70%",
          onToggle: (self) => {
            this.$element.toggleClass("is-active", !self.isActive);
          },
        });
    }
}